export default __webpack_public_path__ + "static/media/qr-banner.f72c47fd.png";